import axios from 'axios';

function get(url) {
	const config = {};

	const token = localStorage.getItem('token');
	if (token) {
		config.headers = {
			authorization: `Bearer ${token}`,
		};
	}

	// return axios.get(process.env.API_URL + url, config);
	return axios.get(window.apiUrl + url, config);
}

async function getAsync(url) {
	const self = this;
	const config = {};

	const token = localStorage.getItem('token');

	if (token) {
		config.headers = {
			authorization: `Bearer ${token}`,
		};
	}

	const result = await axios.get(window.apiUrl + url, config).catch((error) => {
		// console.log("🚀 ~ getAsync ~ error:", error)
		if (error.response.status == 401) {
			self?.store.logout();
			self?.$router.push('/');
		} else if (err.response.data.error) {
			console.error(`getAsync ~ error: ${err.response.data.error}`);
		} else {
			self.isAlert.processing = false;
			self.isAlert.actions.pop();
		}
	});
	// console.log("🚀 ~ getAsync ~ result:", result)

	return result?.data;
}

async function postAsync(url, data, headers, onError = null) {
	let config = { headers: {} };
	const token = localStorage.getItem('token');
	if (token) {
		config.headers = {
			authorization: `Bearer ${token}`,
		};
	}

	if (headers === null) {
		// yy
	} else {
		for (const i in headers) {
			const x = headers[i];
			// config[i] = x;
			config.headers[i] = x;
		}
		// config.headers = headers;
	}

	const self = this;

	const result = await axios.post(window.apiUrl + url, data, config).catch((err) => {
		// console.log("🚀 ~ postAsync ~ err:", err)
		if (onError == null) {
			try {
				if (err.response.status == 401) {
					self?.store.logout();
					//self?.$router.push('/');
				} else if (err.response.data.error) {
					console.error(`postAsync ~ error: ${err.response.data.error}`);
				} else {
					self.isAlert.processing = false;
					self.isAlert.actions.pop();
				}
			} catch (e) {
				// yada
			}
		} else {
			onError(err);
			try {
				self.isAlert.processing = false;
				self.isAlert.actions.pop();
			} catch (e) {
				// yada
			}
		}
		return Promise.reject(err);
	});

	return result?.data;
}

function post(url, data) {
	const config = {};

	const token = localStorage.getItem('token');
	if (token) {
		config.headers = {
			authorization: `Bearer ${token}`,
		};
	}

	const self = this;

	// return axios.post(process.env.API_URL + url, data, config).catch(function (error) {
	return axios.post(window.apiUrl + url, data, config).catch(function (error) {
		try {
			self.hideLoading = false;
		} catch (e) {
			// yada
		}
	});
}

async function deleteAsync(url, body, headers = null, onError = null) {
	let config = {
		headers: {},
		data: body,
	};

	const token = localStorage.getItem('token');
	if (token) {
		config.headers = {
			authorization: `Bearer ${token}`,
		};
	}

	if (headers === null) {
		// yy
	} else {
		for (const i in headers) {
			const x = headers[i];
			config.headers[i] = x;
		}
	}

	const self = this;

	const result = await axios.delete(window.apiUrl + url, config).catch((err) => {
		try {
			self.hideLoading = false;
		} catch (e) {
			// yada
		}

		if (onError == null) {
			try {
				if (err.response.data.error) {
					// window.alert(err.response.data.error);
					console.error(`deleteAsync ~ error: ${err.response.data.error}`);
				} else {
					// window.alert('System is busy, please try again later.');
					self.isAlert.processing = false;
					self.isAlert.actions.pop();
				}
			} catch (e) {
				// yada
			}
		} else {
			onError(err);
			try {
				self.isAlert.processing = false;
				self.isAlert.actions.pop();
			} catch (e) {
				// yada
			}
		}
		return Promise.reject(err);
	});

	return result.data;
}

function isEmpty(q) {
	return q === '' || q === null;
}

function alert(q) {
	window.alert(q);
}

// function getProductUrl(q) {
// 	const temp = productRedirect.find((z) => z.id == q.id);
// 	if (temp) {
// 		return '/product/' + temp.name;
// 	} else {
// 		return '/product/item/' + q.id + '/' + encodeURIComponent(q.name.replace(/\//g, '-'));
// 	}
// }

async function getNoneLoginToken() {
	const result = await postAsync('/appUserLogin/login', {
		userName: process.env.API_USERNAME,
		password: process.env.API_PASSWORD,
	});

	if (result.result) {
		localStorage.setItem('token', result.data.token);
	} else {
		console.error(`getNoneLoginToken ~ error: get token failed`);
		// window.alert('get token failed');
	}

	return result;
}

function getToday(divide = '-') {
	// Get current date

	const today = new Date();

	// Extract year, month, and day
	const year = today.getFullYear();
	const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
	const day = today.getDate().toString().padStart(2, '0');

	// Format the date as 'YYYY/MM/DD'
	const formattedDate = `${year}${divide}${month}${divide}${day}`;

	return formattedDate;
}

function getDate(q = null) {
	try {
		let date = new Date(q) || new Date();

		const offsetMinutes = date.getTimezoneOffset();
		date.setMinutes(date.getMinutes() - offsetMinutes);

		// Get year, month, and date components
		const year = date.getFullYear();
		// Add 1 to month because getMonth() returns values from 0 to 11
		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const day = date.getDate().toString().padStart(2, '0');

		// Return the formatted date
		return `${year}-${month}-${day}`;
	} catch (e) {
		return '--';
	}
}

function getHourMinute(q = null) {
	// Get current time
	try {
		let date = new Date();
		try {
			if (q != null) {
				date = new Date(q);
			}
		} catch (e) {
			// yada
			date = new Date();
		}

		const offsetMinutes = date.getTimezoneOffset();
		date.setMinutes(date.getMinutes() - offsetMinutes);

		// Extract hours and minutes
		let hours = date.getHours();
		const minutes = date.getMinutes();

		// Determine AM/PM
		const amOrPm = hours >= 12 ? 'PM' : 'AM';

		// Convert to 12-hour format
		hours = hours % 12 || 12;

		// Format the time as 'hh:mm AM/PM'
		const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${amOrPm}`;

		return formattedTime;
	} catch (e) {
		return '--';
	}
}

function createCaptcha(captchaAnswer, captcha) {
	//clear the contents of captcha div first
	document.getElementById('captchaFrame').innerHTML = '';
	// let charsArray = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*';
	let charsArray = '0123456789';
	// let lengthOtp = 6;
	let lengthOtp = 4;
	let captchaArray = [];
	for (let i = 0; i < lengthOtp; i++) {
		//below code will not allow Repetition of Characters
		// let index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array

		let randomIndex = Math.floor(Math.random() * charsArray.length);

		captchaArray.push(charsArray[randomIndex]);
		// if (captcha.indexOf(charsArray[index]) == -1) captcha.push(charsArray[index]);
		// else i--;
	}

	let canv = document.createElement('canvas');
	canv.id = 'captcha';
	// canv.width = 100;
	canv.width = 80;
	// canv.height = 50;
	canv.height = 45;
	let ctx = canv.getContext('2d');
	ctx.font = '25px Georgia';
	ctx.strokeText(captchaArray.join(''), 0, 30);
	//storing captcha so that can validate you can save it somewhere else according to your specific requirements
	captchaAnswer.value = captchaArray.join('');

	if (!(process.env.NODE_ENV === 'production')) {
		captcha.value = captchaAnswer.value;
	}

	document.getElementById('captchaFrame').appendChild(canv); // adds the canvas to the body element
	return { captchaAnswer, captcha };
}

async function getBlobData(blobUuid) {
	let data = '';
	const url = `/qa/getBlob/${blobUuid}`;
	const res = await getAsync(url);
	// console.log("🚀 ~ getBlobData ~ res:", res)
	if (res.result) {
		data = res?.data[0]?.data;
	}
	return data;
}

export { post, postAsync, get, isEmpty, alert, getNoneLoginToken, getAsync, getToday, getHourMinute, createCaptcha, getDate, deleteAsync, getBlobData };

export default { post, postAsync, get, isEmpty, alert, getNoneLoginToken, getAsync, getToday, getHourMinute, createCaptcha, getDate, deleteAsync, getBlobData };
